import * as Yup from 'yup'
import i18n from 'core/common/i18n'
import { INVALID_CHARACTERS_REGEX } from 'core/common/utils/validation'

export const ProductCharacteristicsFormSchema = Yup.object().shape({
  brand: Yup.string()
    .trim()
    .min(1, i18n.t('product.validations.minSize', { count: 1 }))
    .max(100, i18n.t('product.validations.maxSize', { count: 100 }))
    .matches(INVALID_CHARACTERS_REGEX, i18n.t('product.validations.invalidCharacters'))
    .required(i18n.t('product.validations.required')),
  modelo: Yup.string()
    .trim()
    .min(1, i18n.t('product.validations.minSize', { count: 1 }))
    .max(100, i18n.t('product.validations.maxSize', { count: 100 }))
    .matches(INVALID_CHARACTERS_REGEX, i18n.t('product.validations.invalidCharacters'))
    .required(i18n.t('product.validations.required')),
  garantia: Yup.string().trim().required(i18n.t('product.validations.required')),
  type: Yup.string().trim().required(i18n.t('product.validations.required')),
})
